import { render, staticRenderFns } from "./ScaleArea.vue?vue&type=template&id=f4077cf6&scoped=true"
import script from "./ScaleArea.vue?vue&type=script&lang=js"
export * from "./ScaleArea.vue?vue&type=script&lang=js"
import style0 from "./ScaleArea.vue?vue&type=style&index=0&id=f4077cf6&prod&scoped=true&lang=css"
import style1 from "./ScaleArea.vue?vue&type=style&index=1&id=f4077cf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4077cf6",
  null
  
)

export default component.exports